import { getCountry } from "../../../common/userfuctions";
import { post } from "../https";

const SERVER_URL = process.env.REACT_APP_HIRE_SIDE_API;

const country = getCountry();

export const SearchCompanies = (
  companyName = "",
  pageNumber = "1",
  AccessToken = "",
  Favorite = "0",
  moreParams = {},
  countryCode
) => {
  let params = {
    r: "Companies",
    rt: "GetCompanies",
    p: JSON.stringify({
      q: companyName,
      pg: pageNumber,
      AccessToken: AccessToken,
      Favorite: Favorite,
      IPCountry: countryCode,
    }),
  };

  return post(SERVER_URL, null, params, moreParams);
};
export const GetUserCompanies = (AccessToken) => {
  let params = {
    r: "Employers",
    rt: "Private",
    p: JSON.stringify({
      rt2: "GetUserCompanies",
      UserToken: AccessToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};
export const GetCompaniesEmbedData = (CompanyCode = "", AccessToken = "", moreParams = {}, countryCode, pg = "1", st = "", filters = {}) => {
  let params = {
    r: "Companies",
    rt: "GetCompaniesEmbedData",
    p: JSON.stringify({
      CompanyCode,
      AccessToken: AccessToken,
      pg: pg,
      st: st,
      q: filters.q || "",
      JobRoleDepartment: filters.jobRole || "",
      LocationId: filters.location || "",
      IPCountry: countryCode,
    }),
  };

  return post(SERVER_URL, null, params, moreParams);
};

export const GetCompanyInfo = (CompanyCode = "", AccessToken = "", moreParams = {}, countryCode, pg = "1" , st = "") => {
  let params = {
    r: "Companies",
    rt: "GetCompanyInfo",
    p: JSON.stringify({
      CompanyCode,
      AccessToken: AccessToken,
      pg: pg,
      st: st,
      IPCountry: countryCode,
    }),
  };

  return post(SERVER_URL, null, params, moreParams);
};

export const GetCompanyReview = (CompanyCode = "", AccessToken = "") => {
  let params = {
    r: "Companies",
    rt: "GetReviews",
    p: JSON.stringify({
      CompanyCode: CompanyCode,
      AccessToken: AccessToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const AddCompanyReview = (data, AccessToken) => {
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "AddReview",
      AccessToken: AccessToken,
      CompanyCode: data.CompanyCode,
      Score: data.Score,
      ReviewTitle: data.ReviewTitle,
      ReviewText: data.ReviewText,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const FavoriteCompany = (CompanyCode, AccessToken) => {
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "FavoriteCompany",
      AccessToken: AccessToken,
      CompanyCode: CompanyCode,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const getFavoriteCompanies = (AccessToken) => {
  let params = {
    r: "Companies",
    rt: "GetCompanies",
    member: 1,
    p: JSON.stringify({
      AccessToken: AccessToken,
      q: "",
      Favorite: 1,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const GetCompanyJobs = (CompanyCode, AccessToken) => {
  let params = {
    r: "Companies",
    rt: "GetJobs",
    p: JSON.stringify({
      AccessToken: AccessToken,
      CompanyCode: CompanyCode,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const CompanySocialLinksForm = (AccessToken, CompanyCode) => {
  let params = {
    r: "Employers",
    rt: "Private",
    p: JSON.stringify({
      rt2: "Companies",
      rt3: "CompanySocialLinksForm",
      UserToken: AccessToken,
      CompanyCode: CompanyCode,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const CompanySocialLinksSave = (AccessToken, CompanyCode, data) => {
  let params = {
    r: "Employers",
    rt: "Private",
    p: JSON.stringify({
      rt2: "Companies",
      rt3: "CompanySocialLinksSave",
      UserToken: AccessToken,
      CompanyCode: CompanyCode,
      data: data,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const editCompanyLogo = (CompanyCode, moreParams = {}) => {
  let params = {
    r: "Companies",
    rt: "EditCompanyLogo",
    p: JSON.stringify({
      CompanyCode: CompanyCode,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params, moreParams);
}
